var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.localVisible,
        title:
          (_vm.isCreateNewVessel ? "Create New " : "Modify ") + _vm.getLabel,
        width: _vm.isSts ? "600px" : "500px",
      },
      on: { close: _vm.handleCloseDialog },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleCloseDialog()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.isSaving },
                  on: { click: _vm.handleSaveVessel },
                },
                [_vm._v("Save")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "vesselFormRef",
              attrs: {
                model: _vm.vesselForm,
                rules: _vm.computedRules,
                "label-width": _vm.isSts ? "170px" : "120px",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.getLabel + " Name:", prop: "vesselName" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "Enter vessel name" },
                    model: {
                      value: _vm.vesselForm.vesselName,
                      callback: function ($$v) {
                        _vm.$set(_vm.vesselForm, "vesselName", $$v)
                      },
                      expression: "vesselForm.vesselName",
                    },
                  }),
                  _vm.selectedVessel
                    ? _c("div", { staticClass: "warning-message" }, [
                        _vm.selectedVessel.lastSyncedMpaBargeFound ||
                        _vm.selectedVessel.lastSyncedMpaVesselFound
                          ? _c("div", [_vm._v(" Exist in MPA ")])
                          : _vm.selectedVessel.lastSyncedMpaBargeFound ===
                              false &&
                            _vm.selectedVessel.lastSyncedMpaVesselFound ===
                              false
                          ? _c("div", [_vm._v(" Not in MPA ")])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.getLabel + " IMO:", prop: "vesselImo" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disableImo,
                      placeholder: "Enter IMO number",
                    },
                    model: {
                      value: _vm.vesselForm.vesselImo,
                      callback: function ($$v) {
                        _vm.$set(_vm.vesselForm, "vesselImo", $$v)
                      },
                      expression: "vesselForm.vesselImo",
                    },
                  }),
                  _vm.vesselForm.vesselImo &&
                  !_vm.isValidImoNo(_vm.vesselForm.vesselImo)
                    ? _c("div", { staticClass: "warning-message" }, [
                        _vm._v(" Not a correct format, please check again "),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "License Number:", prop: "vesselLicenseNo" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disableLicenseNo,
                      placeholder: "Enter license number",
                    },
                    model: {
                      value: _vm.vesselForm.vesselLicenseNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.vesselForm, "vesselLicenseNo", $$v)
                      },
                      expression: "vesselForm.vesselLicenseNo",
                    },
                  }),
                  _vm.licenseFormatError
                    ? _c("div", { staticClass: "warning-message" }, [
                        _vm._v(
                          " Format: S[A|B|C|P|R|T] NNNNA, please check again "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }